export class OptionDenialReason {
  renew: string;
}
